import { useState } from 'react'
import { getCurrentTimezone } from '../helpers/current-timezone.helper'
import { AppConfigContextType } from '../types/app-config-context-type'
import dayjs from 'dayjs'

export const useAppConfigStore = (): AppConfigContextType => {
    const [language, setLanguage] = useState('en-us')
    const [units, setUnits] = useState('metric')
    const [timezone, setTimezone] = useState(getCurrentTimezone())
    const [userData, setUserData] = useState([])
    const [assetEmailNotification, setAssetEmailNotification] = useState(false)
    const [geofenceEmailNotification, setGeofenceEmailNotification] =
        useState(false)
    const [inAppNotification, setInAppNotification] = useState(false)
    const sevenDaysAgo = dayjs(dayjs()).subtract(7, 'days')
    const defaultDateRange = {
        startDate: dayjs(sevenDaysAgo).format('l'),
        endDate: dayjs().format('l'),
    }
    const [notificationDateRange, setNotificationDateRange] =
        useState(defaultDateRange)
    return {
        language,
        units,
        timezone,
        userData,
        assetEmailNotification,
        geofenceEmailNotification,
        inAppNotification,
        notificationDateRange,
        setNotificationDateRange,
        setLanguage,
        setUnits,
        setTimezone,
        setUserData,
        setAssetEmailNotification,
        setGeofenceEmailNotification,
        setInAppNotification,
    }
}
